import React, { Component } from  'react';
import { asJSON } from '../js/util';
import MonacoEditor from 'react-monaco-editor';
import * as stringify from "json-stringify-pretty-compact";
import * as d3 from 'd3';
import * as gemini from 'gemini/gemini.web';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome'
import { faLightbulb } from '@fortawesome/free-solid-svg-icons'
import './css/CodeCol.css'
import {
  Col, Tab, Tabs, Button
} from 'react-bootstrap'



class CodeCol extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recomModalShow: false,
      currTab: "gemini-tab"
    }
  }
  async editorWillMount(monaco) {
    let schema = await d3.json(`${process.env.PUBLIC_URL}/schema.json`);
    monaco.languages.json.jsonDefaults.setDiagnosticsOptions({
        validate: true,
        schemas: [{
            uri: `${process.env.PUBLIC_URL}/schema.json`,
            fileMatch: ['*'],
            schema
        }]
    });
  }

  genEditorDidMount(editorId) {
    let attachEditorRefs = this.props.attachEditorRefs;
    return function(editor, monaco){
      editor.layout();

      let editorRef = {};
      editorRef[editorId] = editor.getModel();
      attachEditorRefs(editorRef)
    }
  }
  genChangeHandler(specType) {
    return (newValue, e) => {
      this.props.onSpecChange(specType, newValue)
    }
  }

  onTabChange(tabKey, e) {
    const TABKEY_TO_EDITORREF = {
      "gemini-tab":"geminiEditor",
      "start-tab":"sVisEditor",
      "end-tab": "eVisEditor"
    };

    this.setState({currTab: tabKey}, () => {
      if (TABKEY_TO_EDITORREF[tabKey]) {
        this.refs[TABKEY_TO_EDITORREF[tabKey]].editor.layout();
      }
    })
  }

  genToVegaBtnClickHandler(specType) {
    let spec = asJSON(specType === "sSpec" ? this.props.sSpecText : this.props.eSpecText);
    return () => {
      if (spec) {
        this.props.onSpecChange(specType, stringify(gemini.vl2vg4gemini(spec)));
      }
    }
  }
  render() {
    const options = {
      lineNumbersMinChars: 4,
      minimap: {enabled: false},
      scrollBeyondLastLine: false,
      selectOnLineNumbers: true,
      indentSize: 2,
      tabSize:2,
      wordWrap: 'bounded',
      wordWrapColumn: 100,
      wordWrapMinified: true,
      wrappingIndent: "indent",
      language: 'json'
    };
    const sSpec = asJSON(this.props.sSpecText),
      eSpec = asJSON(this.props.eSpecText);

    let canRecommend = (sSpec && eSpec) ? gemini.canRecommend(sSpec, eSpec, 2).result : false;

    return <Col className="mt-1 p-0" id="code-col" xs={5}>
      <Tabs transition={false}  onSelect={this.onTabChange.bind(this)} activeKey={this.state.currTab}>
        <Tab
          eventKey="gemini-tab"
          title={<span>
              Gemini
              <Button
                className="ml-2"
                variant="primary"
                size="sm"
                disabled={!canRecommend}
                onClick={async (event) => this.props.showRecomModal()}
              ><Icon icon={faLightbulb}></Icon></Button>
            </span>
          }>

          <MonacoEditor
            ref="geminiEditor"
            language="json"
            theme="vs-light"
            options={options}
            value={this.props.gemSpecText}
            onChange={this.genChangeHandler("gemSpec")}
            editorDidMount={this.genEditorDidMount("editor")}
            editorWillMount={this.editorWillMount}
          />

        </Tab>
        <Tab eventKey="start-tab" title="Start Vis">
          {/* <Button
            size="sm" variant="secondary" className="vl2vgBtn" id ="sViewVgBtn"
            disabled={!allowToVegaButton.sSpec}
            onClick={this.genToVegaBtnClickHandler("sSpec").bind(this)}
          >To Vega
          </Button> */}
          <MonacoEditor
            ref="sVisEditor"
            language="json"
            theme="vs-light"
            options={options}
            value={this.props.sSpecText}
            onChange={this.genChangeHandler("sSpec")}
            editorDidMount={this.genEditorDidMount("sVisEditor")}
          />
        </Tab>
        <Tab eventKey="end-tab" title="End Vis">
          {/* <Button
            size="sm" variant="secondary" className="vl2vgBtn" id ="eViewVgBtn"
            disabled={!allowToVegaButton.eSpec}
            onClick={this.genToVegaBtnClickHandler("eSpec").bind(this)}
          >To Vega
          </Button> */}
          <MonacoEditor
            ref="eVisEditor"
            language="json"
            theme="vs-light"
            options={options}
            value={this.props.eSpecText}
            onChange={this.genChangeHandler("eSpec")}
            editorDidMount={this.genEditorDidMount("eVisEditor")}
          />
        </Tab>
      </Tabs>
    </Col>
  }

  async genGeminiAllAtOnce(sSpec, eSpec) {
    const geminiSpec = await gemini.allAtOnce(sSpec, eSpec);
    this.props.onSpecChange("gemSpec", stringify(geminiSpec))
  }
}

export default CodeCol;
